/* ---------------------------------------------------------------------------
 * PP UPSELL POPUP — behaviour for sections/pp-upsell-popup.liquid
 *
 * A deferred asset rather than an inline <script>: the same 11 kB used to be
 * parsed inside the HTML of every page view, cart or no cart. Nothing here
 * runs before the document is parsed, and the browser caches it across pages.
 *
 * The section prints its id and its copy as JSON (#pp-upsell-popup-config) so
 * this file needs no Liquid.
 * ------------------------------------------------------------------------- */

(function () {
  var WRAPPER_SELECTOR = '.shopify-section--pp-upsell-popup';

  if (window.PPUpsellPopup) return;

  /* Section id and copy come from the JSON the section prints, so this file
     stays Liquid-free and therefore cacheable across every page. */
  var CONFIG = {};
  try {
    CONFIG = JSON.parse(document.getElementById('pp-upsell-popup-config').textContent);
  } catch (e) {
    return;
  }

  var SECTION_ID = CONFIG.sectionId;
  var I18N = CONFIG.i18n || {};

  /* The stylesheet lives inside the section, and refresh() replaces the section's
     markup — which threw the loaded sheet away and re-inserted it at
     media="print", unstyling the popup for a frame or two on every add. Move it to
     <head> once and it survives every re-render; refresh() then strips the copy
     that comes back with the new markup. */
  function hoistStyle() {
    /* The critical rule travels with it: refresh() strips styles from the markup
       it inserts, so in <head> is the only place either of them survives. */
    Array.prototype.forEach.call(
      document.querySelectorAll('link[data-ppup-style], style[data-ppup-critical]'),
      function (node) {
        if (node.tagName === 'LINK') node.media = 'all';
        if (node.parentNode !== document.head) document.head.appendChild(node);
      }
    );
  }

  var refreshing = false;
  var openTimer = null;
  var internalAdd = false;
  var selfRefreshEvent = false;
  var lastFocused = null;

  function wrapper() { return document.querySelector(WRAPPER_SELECTOR); }
  function popup() { return document.getElementById('pp-upsell-popup'); }

  function isCartPage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return document.body.classList.contains('template-cart') || /\/cart$/.test(path);
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function open() {
    var el = popup();
    if (!el || isCartPage()) return;

    lastFocused = document.activeElement;
    el.setAttribute('open', '');
    document.documentElement.classList.add('ppup-lock');

    /* Carousels can only be measured once the popup has a size. Laid out while it was still display:none, every track reported clientWidth 0, every card offsetLeft 0, and the dots and arrows stayed hidden — the whole reason the first build had no visible controls. */
    layoutCarousels(el);

    var closeBtn = el.querySelector('[data-ppup-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    var el = popup();
    if (el) el.removeAttribute('open');
    document.documentElement.classList.remove('ppup-lock');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
    lastFocused = null;
  }

  function isOpen() {
    var el = popup();
    return !!(el && el.hasAttribute('open'));
  }

  /* Adding from inside the popup re-renders it, and a re-render that jumps the customer back to the top of the window loses the row they were reading. Remember where everything was and put it back. */
  function readScroll(host) {
    var state = { body: 0, tracks: [] };
    var body = host.querySelector('[data-ppup-scroll]');
    if (body) state.body = body.scrollTop;
    Array.prototype.forEach.call(host.querySelectorAll('[data-ppup-track]'), function (track) {
      state.tracks.push(track.scrollLeft);
    });
    return state;
  }

  function writeScroll(host, state) {
    var body = host.querySelector('[data-ppup-scroll]');
    if (body && state.body) body.scrollTop = state.body;
    Array.prototype.forEach.call(host.querySelectorAll('[data-ppup-track]'), function (track, i) {
      if (state.tracks[i]) {
        var behavior = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = state.tracks[i];
        track.style.scrollBehavior = behavior;
      }
    });
  }

  /* One fetch per burst of cart activity: the theme both dispatches cart:change and goes through window.fetch for the same add, so without the debounce a single click would re-render the section twice. */
  function refresh(shouldOpen) {
    var host = wrapper();
    if (!host) return;

    /* A second add landing mid-render must not be swallowed: come back for it rather than dropping the open. */
    if (refreshing) {
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { refresh(shouldOpen); }, 300);
      return;
    }

    refreshing = true;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(SECTION_ID) + '&t=' + Date.now();
    var scroll = readScroll(host);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector(WRAPPER_SELECTOR) || doc.body;
        var wasOpen = isOpen();

        /* Assets are already in the document; the copies riding along with the
           new markup would only re-fetch and re-swap. */
        Array.prototype.forEach.call(
          incoming.querySelectorAll('link[data-ppup-style], script[src], style[data-ppup-critical]'),
          function (node) { node.parentNode.removeChild(node); }
        );

        host.innerHTML = incoming.innerHTML;
        bindCarousels(host);
        writeScroll(host, scroll);

        if (shouldOpen || wasOpen) open();
      })
      .catch(function () { /* a failed refresh must never break the page */ })
      .then(function () { refreshing = false; });
  }

  function scheduleOpen() {
    if (isCartPage()) return;
    clearTimeout(openTimer);
    openTimer = setTimeout(function () { refresh(true); }, 220);
  }

  function scheduleSilent() {
    if (isCartPage()) return;
    clearTimeout(openTimer);
    openTimer = setTimeout(function () { refresh(false); }, 220);
  }

  /* ── Add to cart from inside the popup ────────────────────────── Gifts carry the same _Promo properties main-cart.liquid reads, upsells the same _type, so a line added here is indistinguishable from one added on /cart. */
  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var giftProp = button.getAttribute('data-gift-prop');
    var addType = button.getAttribute('data-add-type');
    var original = button.textContent;

    button.disabled = true;
    button.textContent = '…';
    internalAdd = true;

    var form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', '1');
    if (giftProp) {
      form.append('properties[_Promo]', giftProp);
    } else if (addType) {
      form.append('properties[_type]', addType);
    }

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || I18N.error); });
        return res.json();
      })
      .then(function () {
        button.textContent = I18N.added;
        button.classList.add('is-done');

        /* Tell the theme, so the header count and any cart dot follow along; the flag stops our own listener from refreshing a second time. */
        selfRefreshEvent = true;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        internalAdd = false;
        refresh(true);
      })
      .catch(function (err) {
        internalAdd = false;
        button.disabled = false;
        button.textContent = original || I18N.add;
        window.alert(err && err.message ? err.message : I18N.error);
      });
  }

  /* ── Carousels ──────────────────────────────────────────────── Scroll-snap does the moving. The dots and arrows only ask the track to scroll, so touch, trackpad, keyboard and the controls all end up in the same state. Binding and measuring are separate on purpose: listeners can be attached the moment the markup lands, but the number of stops depends on how wide the track actually is, which is only true once the popup is visible — and changes again on rotate, on resize, and when a late image finally has its width. */
  function bindCarousels(root) {
    var rows = (root || document).querySelectorAll('[data-ppup-carousel]');

    Array.prototype.forEach.call(rows, function (row) {
      if (row.__ppupBound) return;

      var track = row.querySelector('[data-ppup-track]');
      var foot = row.querySelector('[data-ppup-controls]');
      var dotsWrap = row.querySelector('[data-ppup-dots]');
      var prev = row.querySelector('[data-ppup-prev]');
      var next = row.querySelector('[data-ppup-next]');
      if (!track || !foot || !dotsWrap) return;

      row.__ppupBound = true;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.ppup-card'));
      var stops = [];

      function step() {
        if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
        return cards.length ? cards[0].offsetWidth : track.clientWidth;
      }

      function offsetOf(card) { return card.offsetLeft - cards[0].offsetLeft; }

      function sync() {
        if (stops.length < 2) return;

        var left = track.scrollLeft;
        var maxLeft = track.scrollWidth - track.clientWidth - 1;
        var active = 0;

        stops.forEach(function (offset, i) {
          if (offset <= left + step() / 2) active = i;
        });

        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.classList.toggle('is-active', i === active);
        });
        if (prev) prev.disabled = left <= 1;
        if (next) next.disabled = left >= maxLeft;
      }

      row.__ppupLayout = function () {
        if (cards.length < 2 || !track.clientWidth) return;

        var maxScroll = track.scrollWidth - track.clientWidth;

        /* A stop is a scroll position the track can actually rest at: every card that can become the left-most one, plus the end of the track when the last of those does not already reach it. Without that last stop a row that overflows by less than one card — three sets on a desktop — had a single stop and hid its own arrows, leaving the overflow unreachable. */
        stops = [];
        cards.forEach(function (card) {
          var offset = offsetOf(card);
          if (offset <= maxScroll - 4) stops.push(offset);
        });
        if (maxScroll > 4 && (stops.length === 0 || stops[stops.length - 1] < maxScroll - 4)) {
          stops.push(maxScroll);
        }

        foot.hidden = stops.length < 2;
        if (foot.hidden) return;

        if (dotsWrap.children.length !== stops.length) {
          dotsWrap.innerHTML = '';
          stops.forEach(function (offset, i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ppup-dot';
            dot.setAttribute('aria-label', I18N.goToItem.replace('__I__', i + 1));
            dot.addEventListener('click', function () {
              track.scrollTo({ left: offset, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
          });
        }

        sync();
      };

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });

      Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', function () { row.__ppupLayout(); }, { once: true });
      });
    });
  }

  function layoutCarousels(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ppup-carousel]'), function (row) {
      if (row.__ppupLayout) row.__ppupLayout();
    });
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (!isOpen()) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { layoutCarousels(popup()); }, 150);
  }, { passive: true });

  /* ── Wiring ────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-ppup-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn);
      return;
    }

    if (e.target.closest('[data-ppup-close]')) {
      e.preventDefault();
      close();
      return;
    }

    /* Clicking the backdrop, i.e. the popup element itself rather than the box inside it. */
    if (isOpen() && e.target === popup()) {
      close();
      return;
    }

    var el = popup();
    if (el && el.getAttribute('data-open-on-cart-click') === 'true' && !isCartPage()) {
      var cartLink = e.target.closest('a[href$="/cart"], [data-action="open-cart"], .header__cart-icon');
      if (cartLink) {
        e.preventDefault();
        scheduleOpen();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  /* Prestige dispatches cart:change on documentElement after every cart mutation it owns, naming the originating event in detail.baseEvent. That is the signal we want: an add opens the popup, anything else only re-renders it. */
  document.addEventListener('cart:change', function (e) {
    if (internalAdd) return;
    var base = e.detail && e.detail.baseEvent;
    if (base === 'variant:add') scheduleOpen();
    else if (isOpen()) scheduleSilent();
  });

  document.addEventListener('cart:refresh', function () {
    if (selfRefreshEvent) { selfRefreshEvent = false; return; }
    if (isOpen()) scheduleSilent();
  });

  /* Fallback for the buttons the theme does not own: the click hijacker in snippets/buy-buttons.liquid, PageFly landing pages and app blocks post to /cart/add themselves and dispatch nothing the theme listens to. The debounce in scheduleOpen() means an add that fires both paths still costs one render. */
  if (!window.PPUpsellFetchPatched) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') !== -1;
      var isMutation = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1;

      var result = origFetch.apply(this, arguments);
      if (!isAdd && !isMutation) return result;

      return result.then(function (response) {
        if (response && response.ok && !internalAdd) {
          if (isAdd) scheduleOpen();
          else if (isOpen()) scheduleSilent();
        }
        return response;
      });
    };
    window.PPUpsellFetchPatched = true;
  }

  window.PPUpsellPopup = { open: open, close: close, refresh: refresh };

  hoistStyle();
  bindCarousels(document);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.matches && e.target.matches(WRAPPER_SELECTOR)) {
      bindCarousels(e.target);
      layoutCarousels(e.target);
    }
  });
})();
